// src/App.js
import React from "react";
import { Router, Route, Switch, Redirect, useLocation } from "react-router-dom";
import { Container } from "reactstrap";

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Login from "./views/Login";
import Welcome from "./views/Welcome";
import Profile from "./views/Profile";
import ExternalApi from "./views/ExternalApi";
import ProtectedRoute from "./utils/ProtectedRoute";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const AppInner = () => {
  const { isLoading, error } = useAuth0();
  const location = useLocation();
  const hideLayout = location.pathname === "/" || location.pathname === "/login";

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div id="app" className="d-flex flex-column h-100">
      {!hideLayout && <NavBar />}

      <Container className="flex-grow-1 mt-5">
        <Switch>
            {/* 1) Redirige "/" directamente a "/login" */}
            <Route exact path="/">
              <Redirect to="/login" />
            </Route>

            {/* 2) /login lanza Login.jsx para disparar loginWithRedirect() */}
            <Route path="/login" component={Login} />

            {/* 3) /welcome: vista de bienvenida, protegida */}
            <ProtectedRoute path="/welcome" component={Welcome} />

            {/* 4) Rutas internas: /profile y /external-api, ambas protegidas */}
            <ProtectedRoute path="/profile" component={Profile} />
            <ProtectedRoute path="/external-api" component={ExternalApi} />

            {/* 5) Cualquier otra ruta va a "/" → "/login" */}
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
        </Container>

      {!hideLayout && <Footer />}
    </div>
  );
};

const App = () => (
  <Router history={history}>
    <AppInner />
  </Router>
);

export default App;
